var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1730_22175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1730_22175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74818 7.2525C9.00852 7.51284 9.43064 7.51284 9.69097 7.2525C9.95137 6.99214 9.95137 6.57003 9.69097 6.30969L8.74818 7.2525ZM7.7587 12.956C8.01904 12.6956 8.01904 12.2736 7.7587 12.0133C7.49835 11.7528 7.07625 11.7528 6.81589 12.0133L7.7587 12.956ZM7.25309 8.74757C6.99273 8.48724 6.57064 8.48724 6.3103 8.74757C6.04994 9.00791 6.04994 9.43004 6.3103 9.69037L7.25309 8.74757ZM8.24391 3.04276C7.98353 3.30311 7.98353 3.72522 8.24391 3.98557C8.50425 4.24592 8.9263 4.24592 9.1867 3.98557L8.24391 3.04276ZM5.91975 7.2525C6.7008 6.47145 7.96715 6.47145 8.74818 7.2525L9.69097 6.30969C8.38924 5.00793 6.27871 5.00793 4.97696 6.30969L5.91975 7.2525ZM6.08152 12.7476C5.30047 13.5287 4.03413 13.5287 3.25309 12.7476L2.3103 13.6904C3.61204 14.9922 5.72258 14.9922 7.02433 13.6904L6.08152 12.7476ZM3.25309 12.7476C2.47204 11.9665 2.47204 10.7002 3.25309 9.91917L2.3103 8.97637C1.00855 10.2781 1.00855 12.3886 2.3103 13.6904L3.25309 12.7476ZM3.25309 9.91917L5.91975 7.2525L4.97696 6.30969L2.3103 8.97637L3.25309 9.91917ZM6.81589 12.0133L6.08152 12.7476L7.02433 13.6904L7.7587 12.956L6.81589 12.0133ZM9.91978 3.2525C10.7008 2.47145 11.9671 2.47145 12.7482 3.2525L13.691 2.30969C12.3892 1.00794 10.2787 1.00794 8.97698 2.30969L9.91978 3.2525ZM12.7482 3.2525C13.5293 4.03354 13.5293 5.29988 12.7482 6.08093L13.691 7.02373C14.9928 5.72198 14.9928 3.61143 13.691 2.30969L12.7482 3.2525ZM10.0815 8.74757C9.30045 9.52864 8.03417 9.52864 7.25309 8.74757L6.3103 9.69037C7.61204 10.9922 9.72257 10.9922 11.0243 9.69037L10.0815 8.74757ZM12.7482 6.08093L10.0815 8.74757L11.0243 9.69037L13.691 7.02373L12.7482 6.08093ZM9.1867 3.98557L9.91978 3.2525L8.97698 2.30969L8.24391 3.04276L9.1867 3.98557Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.fbce50d414d4110157714905c3bd136a.svg";
export { ForwardRef as ReactComponent };